import type { AgeingBucket, BadgeColor, LedgerEntryType } from "@/services/types";

/** Ageing bucket ordering and display metadata. */
export const AGEING_ORDER: AgeingBucket[] = ["not_due", "b1_30", "b31_60", "b61_90", "b90_plus"];

export interface AgeingMeta {
  label: string;
  short: string;
  badge: BadgeColor;
  tone: "default" | "success" | "warning" | "danger";
}

export const AGEING_META: Record<AgeingBucket, AgeingMeta> = {
  not_due: { label: "Not yet due", short: "Not due", badge: "success", tone: "success" },
  b1_30: { label: "1–30 days overdue", short: "1–30 d", badge: "warning", tone: "warning" },
  b31_60: { label: "31–60 days overdue", short: "31–60 d", badge: "warning", tone: "warning" },
  b61_90: { label: "61–90 days overdue", short: "61–90 d", badge: "danger", tone: "danger" },
  b90_plus: { label: "Over 90 days", short: "90+ d", badge: "danger", tone: "danger" },
};

export interface LedgerTypeMeta {
  label: string;
  badge: BadgeColor;
  /** True when the entry reduces the amount a member owes. */
  isCredit: boolean;
}

export const LEDGER_TYPE_META: Record<LedgerEntryType, LedgerTypeMeta> = {
  installment_due: { label: "Installment due", badge: "primary", isCredit: false },
  dividend_credit: { label: "Dividend credit", badge: "accent", isCredit: true },
  payment_received: { label: "Payment received", badge: "success", isCredit: true },
  late_fee: { label: "Late fee", badge: "danger", isCredit: false },
  auction_won: { label: "Auction won", badge: "success", isCredit: true },
  payout_disbursed: { label: "Payout disbursed", badge: "info", isCredit: false },
  adjustment: { label: "Adjustment", badge: "secondary", isCredit: true },
};